import { Permiso } from '../../../../../types/Admin';

export interface PermissionScopePart {
  translationKey: 'administration.zone' | 'administration.supercenter' | 'administration.center';
  value: string;
}

const codeAndName = (code?: string, name?: string): string => {
  const parts = [code?.trim(), name?.trim()].filter(Boolean);
  return parts.length === 2 && parts[0] === parts[1] ? parts[0] || '' : parts.join(' · ');
};

export const getPermissionScopeParts = (permission: Permiso): PermissionScopePart[] => {
  if (permission.objectType === 'system') return [];

  const zone = codeAndName(permission.codZona, permission.nomZona);
  const supercenter = codeAndName(permission.codSupercentro, permission.nomSupercentro);
  const ownLabel = permission.nomProyecto?.trim() || permission.objectCode || permission.objectId;

  if (permission.objectType === 'zone') {
    return [{ translationKey: 'administration.zone', value: ownLabel }];
  }
  if (permission.objectType === 'supercenter') {
    return [
      ...(zone ? [{ translationKey: 'administration.zone' as const, value: zone }] : []),
      { translationKey: 'administration.supercenter', value: ownLabel },
    ];
  }
  return [
    ...(zone ? [{ translationKey: 'administration.zone' as const, value: zone }] : []),
    ...(supercenter ? [{ translationKey: 'administration.supercenter' as const, value: supercenter }] : []),
    { translationKey: 'administration.center', value: ownLabel },
  ];
};
